"use client"

import { useEffect } from 'react';
import { useErrorModal } from '@/contexts/ErrorModalContext.jsx';

export default function ErrorModalSetup() {
  const { showTechnicalError } = useErrorModal();

  useEffect(() => {
    // Set up global error handler function
    if (typeof window !== 'undefined') {
      window.__showTechnicalError = showTechnicalError;
    }

    // Cleanup
    return () => {
      if (typeof window !== 'undefined') {
        delete window.__showTechnicalError;
      }
    };
  }, [showTechnicalError]);

  return null;
}